import Service from "./Service"

class ProductCategoryService extends Service {

    findAll = () => this.get("/product-categories")
}

const productCategoryService = new ProductCategoryService()
export default productCategoryService